'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Mediums = {

    async getAll() {
		try {
			let header = await getHeader();

            let response = await axios.get(API_URL + '/mediums', header);

			return response.data;

		} catch(error) {
            return false;
		}
	},

	async createNew(mediumName, mediumDescription = null) {
		try {
			if (!mediumName) {
				return { error: 'Medium name is required.' };
			}

			let header = await getHeader();

            let response = await axios.post(API_URL + '/medium', {
				"name": mediumName,
				"description": mediumDescription,
				"iconImage": null
			}, header);

			return !response.data.id ? false : response.data;

		} catch(error) {
            return false;
		}
	},

	async update(mediumID, mediumName = null, mediumDescription = null) {
		try {
			if (!mediumID) {
				return { error: 'Medium ID is required' };
			}

			let header = await getHeader();

            let response = await axios.patch(API_URL + '/medium/' + mediumID, {
				"id": mediumID,
				"name": mediumName,
				"description": mediumDescription == "" ? null : mediumDescription,
				"iconImage": null
			}, header);
		
			if (response.data.name) {
				return true;
			}

		} catch(error) {
            return false;
		}
	},

	async uploadImage(mediumID, filename, content) {
		try {

			if (!mediumID || !filename || !content) {
				return { error: 'A mandatory field is missing' };
			}

			let header = await getHeader();

			let response = await axios.post(API_URL + '/medium/upload/' + mediumID, {
				"fileName": filename,
				"content": content
			}, header);

			return !response.data.icon_image ? false : response.data;
		
		} catch(error) {
            return false;
		}
	},

	async delete(mediumID) {
		try {
			if (!mediumID) {
				return { error: 'Medium ID is required' };
			}

			let header = await getHeader();

			let response = await axios.delete(API_URL + '/medium/' + mediumID, header);

			if (response.data.message.includes('Successfully deleted the medium')) {
                return true;
            }

		} catch(error) {
			return false;
		}
	}
    
}

export default Mediums;
